<template>
  <SubLayout
    :pageTitle="title"
    :pageBreadcrumbs="breadcrumbs"
    :hasBack="false"
    :loading="false"
  >
    <template #subHeaderActions>
      <div class="d-flex">
        <ButtonDropdown v-if="$canAccess(moduleAbilities.CRM_INVOICE)  && abilities.PAID_INVOICE"
            :btn-title="$t('button.advance')"
            :search="false"
            :options="[...types]"
            value-field="value"
            name-field="name"
            :showIcon="false"
            @update:modelValue="openAdvancePayModal(true)"
            v-model="paymentFormData.type"

            v-show="['VALIDATED', 'PARTIALLY_PAID'].includes(invoice?.invoice_status) && invoiceStatus.value !== paymentPaidStatus.value && !['CREDITNOTE', 'CANCELED'].includes(invoice?.invoice_status)"
        />
        <Button v-if="$can(abilities.UPDATE_INVOICE) || $can(abilities.UPDATE_ALL_INVOICE)" btn-class="me-3 btn-sm" v-show="invoice?.invoice_status == 'DRAFT'" @click="editInvoice($route.params.id)" type="new" btn-text="crm.invoices.edit" />
        <Button btn-class="me-3 btn-sm" v-if="$can(abilities.SEND_INVOICE)" v-show="['DRAFT','VALIDATED']?.includes(invoice?.invoice_status)" @click.prevent="showSendModal" type="new" btn-text="crm.invoices.send" />
        <Button btn-class="me-3 btn-sm" v-if="$can(abilities.UPDATE_INVOICE) || $can(abilities.UPDATE_ALL_INVOICE)"  v-show="invoice?.invoice_status == 'DRAFT'" @click.prevent="openValidateModal" type="submit" btn-text="invoices.validated" />
        <Button btn-class="me-3 btn-sm" v-if="$can(abilities.ARCHIVE_INVOICE)" v-show="!invoice?.archived_at" @click.prevent="openArchiveModal" type="cancel" btn-text="invoices.archived" />
        <Button btn-class="me-3 btn-sm" v-if="$can(abilities.PAID_INVOICE)" v-show="['VALIDATED', 'PARTIALLY_PAID'].includes(invoice?.invoice_status) && invoiceStatus.value !== paymentPaidStatus.value && !['CREDITNOTE', 'CANCELED'].includes(invoice?.invoice_status)" @click.prevent="openPayModal(false)" type="submit" btn-text="crm.invoices.paid" />
        <Button icon-class="fas fa-backspace" btn-class="btn-sm" type="cancel" btn-text="crm.back" @click="$router.go(-1)"/>
      </div>
    </template>
    <template #layoutContent>
      <Loader :isLoading="isLoading">
        <div class="row d-flex flex-wrap px-5">
            <div class="card p-5 mb-4 me-md-5 flex-grow-1 col-12 col-md-3 col-lg-3">
              <Button
                  btn-class="mb-5 btn-sm"
                  v-if="(invoiceStatus.value == paymentPaidStatus.value) && $can(abilities.CREDIT_INVOICE)"
                  @click="generateInvoice"
                  icon-class="fa fa-file-invoice-dollar"
                  type="new" height="45px"
                  btn-text="crm.invoices.generate_facture" />
              <Button
                  btn-class="mb-5 btn-sm"
                  v-if="((invoice.invoice_status == paymentPaidStatus.value && !invoice.normalizedData) || invoice.invoice_status ==  invoiceStatusEnums.CREDIT_NOTE) && $can(abilities.NORMALIZE_INVOICE)"
                  @click.prevent="normalizeInvoice"
                  icon-class="fa fa-file-invoice-dollar"
                  type="new" height="45px" 
                  :is-loading="isLoadingNormalization"
                  btn-text="crm.invoices.normalize"/>

              <Button btn-class="mb-5 btn-sm" v-if="invoice?.invoice_status == paymentPaidStatus.value && invoice?.payments?.length > 1 && !invoiceSold" @click="generateInvoiceSold" icon-class="fa fa-file-invoice-dollar" type="new" height="45px" btn-text="invoices.invoiceSold"></Button>
              <Button btn-class="mb-5 btn-sm" v-if="invoiceSold" @click="showInvoice" icon-class="fa fa-file-invoice-dollar" type="new" height="45px" btn-text="invoices.invoice"></Button>

              <div v-if="$canAccess(moduleAbilities.CRM_INVOICE)" class="card shadow mb-5 p-5" v-show="invoice?.estimate_id">
                <div class="d-flex align-items-center flex-row-fluid flex-wrap py-1">
                  <div class="d-flex flex-grow-1 me-2">
                    <h5 class="me-2">{{ $t('invoices.devis') }} N° </h5> 
                    <div>{{invoice?.estimate_number}}</div>
                  </div>
                  <router-link :to="{name: 'estimates-view', params: { id: invoice?.estimate_id } }" v-if="$can(abilities.VIEW_ESTIMATE) || $can(abilities.VIEW_ALL_ESTIMATE)"  class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px">
                        <i class="fas fa-eye"></i>
                  </router-link>
                </div>
              </div>
              <div class="card col-12 shadow mb-5 p-5" v-if="invoice?.opportunity_id">
                <div class="d-flex align-items-center flex-row-fluid flex-wrap w-100">
                    <div class="d-flex flex-grow-1">
                        <h5 class="me-2 text-nowrap">{{ $t('crm.pipeline.label.name') }} : </h5>
                        <div class="text-nowrap">{{ invoice?.opportunity_name?.length > 20 ? invoice?.opportunity_name.substring(0, 20) + '...' : invoice?.opportunity_name  }}</div>
                    </div>
                    <router-link :to="{name: 'pipelines-view', params: { id: invoice?.opportunity_id } }" v-if="$can(abilities.VIEW_OPPORTUNITIES) || $can(abilities.VIEW_ALL_OPPORTUNITIES)" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px">
                        <i class="fas fa-eye"></i>
                    </router-link>
                </div>
                </div>
              <div class="card sh adow mb-5 p-5"  v-if="invoice?.original_invoice_number || invoice?.credit_note_number">
                <div v-if="invoice?.credit_note_number" class="d-flex align-items-center flex-row-fluid flex-wrap py-1">
                  <div class="d-flex flex-grow-1 me-2">
                    <h5 class="me-2">{{ $t('invoices.cancelInvoice') }}  </h5>
                    <div>{{ invoice?.credit_note_number }}</div>
                  </div>
                  <a  @click="cancelInvoice(invoice.credit_note_id)"  class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px">
                        <i class="fas fa-eye"></i>
                  </a>
                </div>
                <div v-if="invoice?.original_invoice_number" class="d-flex align-items-center flex-row-fluid flex-wrap py-1">
                  <div class="d-flex flex-grow-1 me-2">
                    <h5 class="me-2">{{ $t('invoice.original_invoice') }} N° </h5>
                    <div>{{ invoice?.original_invoice_number }}</div>
                  </div>
                  <a @click="originInvoice(invoice.original_invoice_id)"  v-if="$can(abilities.VIEW_INVOICE) || $can(abilities.VIEW_ALL_INVOICE)" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px">
                    <i class="fas fa-eye"></i>
                  </a>
                </div>
              </div>
              <div class="card shadow mb-5 p-5" v-show="invoice?.advances?.length > 0" v-if="$canAccess(moduleAbilities.CRM_INVOICE)  && ($can(abilities.VIEW_PAYMENT) || $can(abilities.VIEW_ALL_PAYMENT))">
                <div class="d-flex">
                  <h5 class="me-5 mb-3">{{ $t('invoice.title.advances') }} </h5>
                </div>
                <div class="row d-flex flex-stack hover_div" v-for="(advance, index) in invoice?.advances" :key="index" >
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap py-1">
                    <div class="flex-grow-1 me-2">
                      <div class="text-gray-800 fs-6 fw-bold">
                        {{advance.advance_number }} <span class="badge ms-2" :class="'badge-light-'+filterStatus(advance?.status)[0]?.color">{{ filterStatus(advance?.status)[0]?.[locale] }}</span>
                      </div>
                      <span class="text-muted fw-semibold d-block fs-7">{{ $formatLocalAmount(advance.amount) }} {{ invoice?.currency?.symbol }} ({{ advance.percentage  }} %) </span>
                    </div>
                    <span @click="goToAdvance(advance.id)"  v-if="$can(abilities.VIEW_PAYMENT) || $can(abilities.VIEW_ALL_PAYMENT)" class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px">
                        <i class="fas fa-eye"></i>
                      </span>
                  </div>
                </div>
              </div>
              <div class="card shadow mb-5 p-5" v-show="invoice?.payments?.length > 0" v-if="$canAccess(moduleAbilities.CRM_INVOICE) && ($can(abilities.VIEW_PAYMENT) || $can(abilities.VIEW_ALL_PAYMENT))">
                  <div class="d-flex">
                      <h5 class="me-5 mb-3">{{ $t('invoice.title.payments') }} </h5>
                  </div>
                  <div class="row d-flex flex-stack hover_div" v-for="(payment, index) in invoice?.payments" :key="index" >
                    <div class="d-flex align-items-center flex-row-fluid flex-wrap py-1">
                      <div class="flex-grow-1 me-2">
                        <div class="text-gray-800 fs-6 fw-bold">
                          {{payment.payment_number }} <span class="badge ms-2" :class="'badge-light-'+filterStatus(payment?.status)[0]?.color">{{ filterStatus(payment?.status)[0]?.[locale] }}</span>
                        </div>
                        <span class="text-muted fw-semibold d-block fs-7">{{ $formatLocalAmount(payment.amount) }} {{ invoice?.currency?.symbol }} ({{ payment.percentage  }} %) </span>
                      </div>
                      <span @click="goToPayment(payment.id)"  class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary w-30px h-30px">
                        <i class="fas fa-eye"></i>
                      </span>
                    </div>
                  </div>
              </div>
              <div class="card shadow p-5 mb-5">
                  <div class="d-flex justify-content-between border-bottom py-5">
                      <div>{{ $t('invoices.paidAmount') }}</div>
                      <div>{{invoice?.invoice_status == 'AVOIR' ? 0 : $formatLocalAmount(parseFloat(invoice.total_ht + invoice.invoice_total_tax))}} {{ invoice?.currency?.symbol }}</div>
                  </div>
                  <div class="d-flex justify-content-between pt-5" style="color: #0072CE;">
                      <div>{{ $t('invoices.remainAmount') }}</div> 
                      <div>{{ invoice?.invoice_status == 'AVOIR' ? 0 : $formatLocalAmount(invoice?.remaining_payment) }} {{ invoice?.currency?.symbol }}</div>
                  </div>
              </div>
              <div class="card shadow-sm mb-5 p-5" v-show="invoice.notes">
                  <div class="d-flex">
                    <h5 class="me-5 mb-3">{{ $t('crm.estimate.label.addNote') }} </h5>
                  </div>
                  <p>{{ invoice?.notes }}</p>
              </div>
            </div>
            <div class="card card-px-0 px-0 flex-grow-3 flex-md-grow-1 col-12 col-md-3 col-lg-3" style="flex: 1 1 60%;">
                <Show :cancel="cancel" :sold="invoiceSold" :invoice="invoice">
                  <div class="w-100 table-responsive" v-if="isNormalized" style="border: solid rgb(0, 114, 206) 1px;padding: 1px;margin: 6px" >
                    <table class="table">
                      <thead>
                      <tr>
                        <th></th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="qr-text">
                        <td style="padding: 3px; ">
                          <div class="d-flex justify-content-between">
                            <span>{{ $t('invoice.code_dgi')}}</span>
                            <span style="font-size: 12px;">  {{ symefResponse.codeMECeFDGI }}</span>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span>{{ $t('invoice.code_nim')}}</span>
                            <span style="font-size: 12px;">  {{ symefResponse.nim }} </span>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span>{{ $t('invoice.code_compteur')}}</span>
                            <span style="font-size: 12px;">  {{ symefResponse.counters }} </span>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span>{{ $t('invoice.mecef_heure')}}</span>
                            <span style="font-size: 12px;"> {{ symefResponse.dateTime }} </span>
                          </div>
                        </td>
                      </tr>
                      <tr class="qr-text">
                        <td colspan="2" class="text-center">
                          <QRCodeVue3
                              :width="100"
                              :height="100"
                              :value="symefResponse.qrCode"
                              :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                              :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                              :dotsOptions="{type: 'square', gradient: {type: 'linear', rotation: 0, colorStops: [{ offset: 0, color: 'black' }]}}"
                          />
                        </td>
                      </tr>
                      </tbody>
                    </table>

                  </div>
                </Show>
                <div class="card-toolbar">
                  <AlertModal v-model:showingAlert="showingAlert" @cancel="cancelSend"/>
                </div>
            </div>

        </div>
      </Loader>
    </template>
  </SubLayout>
  <SendModal id="sendModal" :title="$t('invoices.send')" @submit="submitSend" type="INVOICE" :is-loading="isLoadingSend" :content="emailFormData" :file_number="$t('invoices.invoice') +'  '+ invoice.invoice_number"/>
  <AdvanceModal v-if="$can(abilities.PAID_INVOICE)" id="paidAdvanceModal" :advance="paymentFormData" :invoice="invoice" @load="loadInvoice"/>
  <PayModal v-if="$can(abilities.PAID_INVOICE)" id="paidModal" :payment="paymentFormData" :invoice="invoice" @load="loadInvoice"/>
</template>

<script setup>

import QRCodeVue3 from "qrcode-vue3";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {computed, onMounted, ref, watch} from "vue";
import {$formatLocalAmount} from "@/mixins/Helpers";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import Button from "@/components/Button";
import Show from "./components/Show.vue"
import SendModal from "@/Modules/CRM/components/Modals/SendModal.vue"
import PayModal from "@/Modules/CRM/components/Modals/Invoice/PayModal.vue"
import ButtonDropdown from "@/components/ButtonDropdown.vue";
import i18n from "@/plugins/i18n";
import {useSwal} from "@/composables/useSwal";
import Loader from "@/components/Loader";
import AlertModal from '@/Modules/CRM/components/Modals/AlertModal.vue';
import { useLocales } from "@/composables/locales";
import AdvanceModal from "@/Modules/CRM/components/Modals/Invoice/AdvanceModal";
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
import {useInvoiceEnums} from "@/composables/invoiceEnums";

const {locale} = useLocales()
const store = useStore()
const route = useRoute()
const router = useRouter()

const {showSwal} = useSwal()
const {invoiceStatusEnums} = useInvoiceEnums()
const today = new Date();
const day = String(today.getDate()).padStart(2, '0');
const month = String(today.getMonth() + 1).padStart(2, '0');
const year = today.getFullYear();
const formattedStartDate = `${day}-${month}-${year}`;

const title = ref("breadcrumbs.invoice.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.invoice.list',
    route: 'invoices',
    params: {}
  },
  {
    name: 'breadcrumbs.invoice.detail',
    route: 'invoices-view',
    params: { id: route.params.id }
  }
])
const types = ref([
    {
        value: "amount",
        name: i18n.global.t("discount.type.fixed")
    },
    {
        value: "percent",
        name: i18n.global.t("discount.type.percent")
    }
])

const isLoading = ref(false)
const isLoadingSend = ref(false)

const cancel = ref(false)

const invoiceSold = ref(false)

const showingAlert = ref(false)

const symefResponse = ref({})
const isNormalized = ref(false)
const isLoadingNormalization = ref(false)

const paymentFormData = ref({
  isAdvance: false,
  invoice_id: route.params.id,
  payment_type_id: "",
  account_id: "",
  box_id: "",
  exchange_rate: "",
  payment_account_type: "account",
  value: 0,
  amount: 0,
  date: formattedStartDate,
  payment_date: formattedStartDate,
  type: "",
  files: [],
  status: '',
  due_date: formattedStartDate
})

const advancePaymentFormData = ref({
  isAdvance: false,
  invoice_id: route.params.id,
  payment_type_id: "",
  account_id: "",
  box_id: "",
  exchange_rate : "",
  payment_account_type: "account",
  value: 0,
  amount: 0,
  date: formattedStartDate,
  payment_date: formattedStartDate,
  type: "",
  files: [],
  status: '',
  due_date: formattedStartDate
})
const emailFormData = ref({
  invoiceId: route.params.id,
  body: "",
  subject: i18n.global.t('invoices.invoice'),
  facture: "",
  to: [],
  from: ''
})
const invoice = computed(() => store.getters['invoices/currentInvoice'])
const paymentStatus = computed(() => store.getters['payments/paymentStatus'])
const paymentPaidStatus = computed(() => paymentStatus.value.find(el => el.value === invoiceStatusEnums.value.PAID ) || '')
const invoiceStatus = computed(() => paymentStatus.value.find(el => el.value == invoice.value.invoice_status) || '')
const company = computed(() => store.getters['company/getCompanyInfos'])
const currentCompany = Ls.get('current.company')


const normalizeInvoiceType = computed(() => {
  if (invoice.value.invoice_status === invoiceStatusEnums.value.PAID) {
    return 'FV';
  } else if (invoice.value.invoice_status === invoiceStatusEnums.value.CREDIT_NOTE) {
    return 'FA';
  }
  return null;
});
watch(() => invoice.value, () => {
  paymentFormData.value.amount = invoice.value.remaining_payment
  emailFormData.value.to = [invoice.value?.contact?.email]
  if(invoice.value.normalizedData) {
    verifySymefInvoice()
  }
})

watch(() => company.value, () => {
  emailFormData.value.from = company.value?.society?.society_email
})

watch(() => route.params.id, (value) => {
  if(value){
    loadInvoice(route.params.id)
  }
})

function openAdvancePayModal(paidValue) {
  paymentFormData.value.payment_type_id = invoice.value.paymentType?.id
  paymentFormData.value.isAdvance = paidValue
  if(!paidValue){
    paymentFormData.value.type = 'amount'
    let paymentPaid = invoice.value?.advances?.filter(pay => pay.status === 'PAID')
    if(paymentPaid?.length > 0  ){
      let amountToPay = parseFloat(invoice.value.total) - paymentPaid?.reduce((acc,pay) => acc + parseFloat(pay.amount) , 0)
      paymentFormData.value.value  = amountToPay
    }else{
      paymentFormData.value.value =  invoice.value.total
    }

     if(invoice.value?.advances?.length >= 1){
      showSwal(
          i18n.global.t('crm.payments.swal.title'),
          i18n.global.t('crm.payments.swal.cancel_acompte')
      ).then( async (result) => {
          if (result.value) {
            $('#paidAdvanceModal').modal('toggle')
          }
      });
    }else{
      $('#paidAdvanceModal').modal('toggle')
    }
  }else{
    paymentFormData.value.value = (paymentFormData.value.type == 'percent' ? invoice.value?.remaining_percent : 0)
    $('#paidAdvanceModal').modal('toggle')
  }
}

function openPayModal(paidValue) {
  paymentFormData.value.isAdvance = paidValue
  paymentFormData.value.payment_type_id = invoice.value.paymentType?.id
  if(!paidValue){
    paymentFormData.value.type = 'amount'
    let paymentPaid = invoice.value?.advances?.filter(pay => pay.status === 'PAID')
    if(paymentPaid?.length > 0  ){
      let amountToPay = parseFloat(invoice.value.total) - paymentPaid?.reduce((acc,pay) => acc + parseFloat(pay.amount) , 0)
      paymentFormData.value.value  = amountToPay
    }else{
      paymentFormData.value.value =  invoice.value.total
    }

     if(invoice.value?.advances?.length >= 1){
      showSwal(
          i18n.global.t('crm.payments.swal.title'),
          i18n.global.t('crm.payments.swal.cancel_acompte')
      ).then( async (result) => {
          if (result.value) {
            $('#paidModal').modal('toggle')
          }
      });
    }else{
      $('#paidModal').modal('toggle')
    }
  }else{
    paymentFormData.value.value = (paymentFormData.value.type == 'percent' ? invoice.value?.remaining_percent : 0)
    $('#paidModal').modal('toggle')
  }
}

function editInvoice(id){
    router.push({ name: 'invoices-edit', params: {id: id} })
}

function goToAdvance(id){
    router.push({ name: 'advances-view', params: {id: id} })
}

function goToPayment(id){
  router.push({ name: 'payments-view', params: {id: id} })
}

function cancelInvoice(id){
  cancel.value = true
  router.push({ name: 'invoices-view', params: { id: id } })
}

function originInvoice(id){
  cancel.value = false
  router.push({ name: 'invoices-view', params: { id: id } })
}

function showSendModal() {
  $("#sendModal").modal('toggle');
}

function alertDiv(){    
    showingAlert.value = true;
    $('#sendModal').modal('toggle')
    setTimeout(() => {
      showingAlert.value = false;
    }, 5000);
}

function generateInvoice(){
    showSwal(
        i18n.global.t('crm.invoices.swal.title'),
        i18n.global.t('crm.invoices.swal.generate')
    ).then( async (result) => {
        if (result.value) {
            try {
              store.dispatch('invoices/saveInvoiceCreditNote', route.params.id)
                .then((res) => {
                  cancelInvoice(res.data?.data?.id)
                  window.toastr['success'](i18n.global.t('notification.invoice_generate'))
                })
                .catch(() => {
                })
            }catch (e) {

            }
        }
    });
}

function generateInvoiceSold(){
    showSwal(
        i18n.global.t('invoices.invoiceSold'),
        i18n.global.t('crm.invoices.swal.generate_invoice_sold'),
        'info',
        "rgba(0, 114, 206, 1)"
    ).then( async (result) => {
        if (result.value) {
          invoiceSold.value = true
        }
    });
}

function showInvoice(){
  invoiceSold.value = false
}

function submitSend () {
  isLoadingSend.value = true
  store.dispatch('invoices/sendInvoice', emailFormData.value)
      .then(() => {
        $("#sendModal").modal('toggle');
        emailFormData.value.to = [invoice.value?.contact?.email]
        window.toastr['success'](i18n.global.t('notification.invoice_send'))
        isLoadingSend.value = false
        alertDiv()
      })
      .catch(() => {
        isLoadingSend.value = false
      })
}

function loadInvoice(id){
  if(id){
    store.dispatch('invoices/getInvoiceById', id)
  }else{
    store.dispatch('invoices/getInvoiceById', route.params.id)
  }
}

function openValidateModal(){
  showSwal(
        i18n.global.t('invoices.swal.validate'),
        i18n.global.t('invoices.swal.validate_text')
    ).then( async (result) => {
        if (result.value) {
            store.dispatch('invoices/validatedInvoice', {id: route.params.id})
                .then(() => {
                    window.toastr['success'](i18n.global.t('notification.invoice_validated'))
                    loadInvoice()
                })
                .catch(() => {

                })
        }
    })
}

function openArchiveModal(){
  showSwal(
        i18n.global.t('invoices.swal.archive'),
        i18n.global.t('invoices.swal.archive_text')
    ).then( async (result) => {
        if (result.value) {
            store.dispatch('invoices/archivedInvoice', {id: route.params.id})
                .then(() => {
                    window.toastr['success'](i18n.global.t('notification.invoice_archived'))
                    loadInvoice()
                })
                .catch(() => {

                })
        }
    })
}

function loadData () {
  isLoading.value = true
  Promise.all([
    store.dispatch('payments/loadPaymentTypes'),
    store.dispatch('payments/loadPaymentStatus'),
    store.dispatch('invoices/loadInvoiceStatus'),
    store.dispatch('company/generalInformation'),
    loadInvoice(),
  ]).finally(() => isLoading.value = false )
}

function cancelSend(){
    store.dispatch('invoices/cancelInvoiceMail',route.params.id)
        .then(() => {
            window.toastr['success'](i18n.global.t('notification.mail_cancelled'))
            showingAlert.value = false;
        })
        .catch(() => {
          showingAlert.value = false;
        })
}

function filterStatus(value){
  let status = paymentStatus.value.filter(status => status.value === value)
  return status
}

async function verifySymefInvoice(){
  isNormalized.value = false
  await store.dispatch('invoices/verifyInvoiceNormalization', route.params.id).then((res) => {
    symefResponse.value = res.data
    if(symefResponse.value) {
      isNormalized.value = true
    }
  })
}

function normalizeInvoice() {
  showSwal(
      '',
      i18n.global.t('crm.invoices.swal.normalization_invoice_sold'),
      'info',
      "rgba(0, 114, 206, 1)"
  ).then( async (result) => {
    if(result.value) {
      isLoadingNormalization.value = true
      store.dispatch('invoices/normalizationInvoice', {invoice_id: route.params.id, society_id: currentCompany, type : normalizeInvoiceType?.value})
          .then((res) => {
        loadInvoice()
      }).finally(() => isLoadingNormalization.value = false)

    }
  });
}


onMounted(() => {
  paymentFormData.value.payment_account_type = 'account'

  loadData()
})


</script>

<style scoped>
.card-parent {
    position: relative;
}

.card-child {
    position: absolute;
    bottom: 0;
    width: 90%;
    font-weight: 500;
    margin-bottom: 20px;
}

.shadow {
    box-shadow: 0 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, .075) !important;
}

.hover_div {
    position: relative;
}

.hover_div:hover {
    background-color: #0072CE0D;
    border-radius: 5px;
}
</style>
